import React from 'react'
import { TrialPreEndModalCard } from 'Features/accountSettings/components/Billing/TrialPreEndModal/TrialPreEndModal.styled'
import { Tooltip } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import {
  TrialPreEndModalCardNumber,
  TrialPreEndModalCardText,
  TrialPreEndModalCardTextWrapper,
} from 'Features/accountSettings/components/Billing/TrialPreEndModal/PaidMarketingData/PaidMarketingData.styled'
import { TotalVisitsStyled } from './TotalVisits.styled'

export const TotalVisits = ({ totalVisits, bundle }: { totalVisits: string; bundle?: boolean }) => {
  const { t } = useTranslation('accountSettings')

  return (
    <TrialPreEndModalCard bundle={bundle}>
      <TotalVisitsStyled>
        <TrialPreEndModalCardTextWrapper>
          <TrialPreEndModalCardText>
            {t('trial_pre_end_modal.total_visits')}
          </TrialPreEndModalCardText>
          <Tooltip
            trigerStyle={{
              style: { color: 'var(--colors-neutral)', marginTop: '22px' },
            }}
            tooltiptContent={t('trial_pre_end_modal.total_visits_tooltip')}
          />
        </TrialPreEndModalCardTextWrapper>
        <TrialPreEndModalCardNumber>{totalVisits}</TrialPreEndModalCardNumber>
      </TotalVisitsStyled>
    </TrialPreEndModalCard>
  )
}
